import styled from 'styled-components';

export const Indent = styled.div({
    marginLeft: 10
});
